import styled from 'styled-components'

const StyledStoriesView = styled.div`
  h1 {
    margin: 1rem 0 2rem 0;
    font-size: 36px;
    font-weight: 400;
    letter-spacing: -0.25px;
    font-family: ${({ theme }) => theme.fonts.lexend};
  }

  .stories-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem 1rem;
    overflow: hidden;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}px) {
    h1 {
      margin: 4rem 0 3rem 0;
      font-size: 40px;
    }

    .stories-list {
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      grid-gap: 24px 12px;
    }
  }
`

export default StyledStoriesView
